import React from 'react';
import { runtimeEnv } from 'config/runtimeEnv';
import EditChargesDialog from './EditChargesDialog';
import DutySlipDialogV2 from './dutySlipV2/DutySlipDialogV2';

// The switch between the old duty slip dialog and the new one (2026-09-26).
// Both take the same props. DUTY_SLIP_V2 is read through runtimeEnv, so it
// can be set as REACT_APP_DUTY_SLIP_V2 at build time or flipped per
// deployment in public/env.js without a rebuild. Anything other than "true"
// keeps the old dialog; rollback is turning it off.
export const isDutySlipV2Enabled = () =>
  `${runtimeEnv('DUTY_SLIP_V2', 'false')}`.trim().toLowerCase() === 'true';

const DutySlipDialog = (props) =>
  isDutySlipV2Enabled() ? <DutySlipDialogV2 {...props} /> : <EditChargesDialog {...props} />;

export default DutySlipDialog;
